import { useAppQuery } from "../../../http/useAppQuery.ts";
import type { Asset } from "../types.ts";
import { useBoardUuid } from "./useBoardUuid.ts";

export const useBoardAssets = ({
  showDeletedAssets = false,
}: {
  showDeletedAssets?: boolean;
} = {}) => {
  const boardUuid = useBoardUuid();

  const assetQuery = useAppQuery<Asset[]>({
    queryKey: `boards/${boardUuid}/assets`,
    queryParamsKey: showDeletedAssets
      ? { include_deleted: showDeletedAssets.toString() }
      : undefined,
  });

  return {
    assets: assetQuery.data,
    isLoading: assetQuery.isLoading,
  };
};
